import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { LookInside } from './components/LookInside';
import { Tomes } from './components/Tomes';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { Reviews } from './components/Reviews';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { techVoices, moreTechVoices } from './data/testimonials';
export function App() {
  return <div className="min-h-screen w-full bg-paper font-sans text-pine selection:bg-ember selection:text-pine" data-id="element-0" data-mp="3mlja0y7k5j4n">
      <MetaPixel data-id="element-1" data-mp="3rcj6y3gog175" />
      <main data-id="element-2" data-mp="3rbzmaezn6ypf">
        <Hero data-id="element-3" data-mp="3rdarmj8qkein" />
        <SocialProofBar data-id="element-4" data-mp="3rcsw5otwe4bs" />
        <PainGrid data-id="element-5" data-mp="3reltgdimfc74" />
        <ProductReveal data-id="element-6" data-mp="5otf64sd496" />
        <LookInside data-id="element-7" data-mp="682dxcgkib2" />
        <Tomes data-id="element-8" data-mp="5gel8p3rovc" />
        <Bonuses data-id="element-9" data-mp="56qxrrj5tst" />
        <ValueStack data-id="element-10" data-mp="7sxpp6lk59z" />
        <Urgency data-id="element-11" data-mp="2zlle8zeb8glo" />
        <Pricing data-id="element-12" data-mp="2zm4ywnvchj3e" />
        <Reviews data-id="element-13" data-mp="2zmo3z3zwcd00" />
        <Testimonials voices={techVoices} background="white" data-id="element-14" data-mp="2zn6aquk6q9m6" />
        <Guarantee data-id="element-15" data-mp="33nq5jrhad155" />
        <Faq data-id="element-16" data-mp="33n6wl09m5n39" />
        <Testimonials voices={moreTechVoices} title="Every tech hits the same calls" background="panel" data-id="element-17" data-mp="33orjq4tlm3r3" />
        <CostOfInaction data-id="element-18" data-mp="3dle4ktlxcut4" />
        <Close data-id="element-19" data-mp="3dlnsmbnesrw6" />
      </main>
      <Footer data-id="element-20" data-mp="3dirvuqnas99b" />
      <PurchaseNotifications data-id="element-21" data-mp="nvj5hlha6osd" />
    </div>;
}